import React from 'react';

// relements
import Box from 'relements/build/esm/ui/box';
import Text from 'relements/build/esm/ui/text';
import Checkbox from 'relements/build/esm/input/checkbox';
import Radio from 'relements/build/esm/input/radio';
import Button from 'relements/build/esm/ui/button';
import Icon from 'relements/build/esm/ui/icon';
import Modal from 'relements/build/esm/overlays/modal';
import Tooltip from 'relements/build/esm/overlays/tooltip';
import InfoIconV4 from 'relements/build/esm/ui/icons/InfoIconV4';

// actions
import { createAlert } from '@src/actions/BotActions';

// icons
import TrainIcon from '@src/containers/SubStories/Header/icons/train.svg';
import SuccessIcon from '@src/components/Icon/Success.svg';
import ErrorIcon from '@src/components/Icon/error.svg';
import LoadingIcon from '@src/components/Icon/loading.svg';

// components
import Training from '@src/containers/SubStories/Header/components/TrainButton/Training';

// api
import { API } from '@src/api';

// utils
import { isProduction } from '@src/utils';

// store
import BotStore from '@src/store';
import CommonStore from '@src/stores/CommonStore';

// constants
import { AlertTypes } from '@src/constants/MogamboConstants';
import Label from './components/Label';
import {
  ACTIONS,
  additionalFeaturesList,
  API_ACTIONS,
  hslDefaultText,
  mapPersonalityListValueToTitle,
  personalityList,
} from './const';

// Styled Components
import { TrainButton } from '../../../WebGuide/components/StyledComponets';
import {
  IconWrapper,
  Wrapper,
  AdditionalFeatures,
  StyledButton,
  StyledChips,
  StyledTextInput,
  StyledIcon,
  MainWrapper,
  StyledLoader,
  StyledDropdown,
} from './StyledComponents';
import UserDetailsFilter from './components/UserDetailsFilter';

const intialState = {
  isLoading: false,
  trainingStatus: '',
  brandName: '',
  productList: [],
  catalogId: '',
  refreshRate: { text: '12' },
  additionalFeatures: additionalFeaturesList,
  personality: {
    title: 'Formal',
    value: 'formal',
  },
  isEdit: false,
  afterSaveState: {
    state: '',
    subMessage: '',
    mainMessage: '',
  },
  isAdditionalFeatureAccordianActive: false,
  errors: {
    brandName: '',
    productList: '',
    catalogId: '',
    userKey: '',
    hsl: '',
  },
  hslValue: {
    text: hslDefaultText,
    type: 'TEXT',
  },
  userDetailsToggle: false,
  userKey: '',
  catalogFilterKey: { text: '' },
  catalogFilterList: [],
};

// Reducer function
const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_INITIAL_DATA:
      return { ...state, ...action.payload };
    case ACTIONS.UPDATE_BRAND_NAME:
      return { ...state, brandName: action.payload, isEdit: true };
    case ACTIONS.UPDATE_PRODUCT_LIST:
      return { ...state, productList: action.payload, isEdit: true };
    case ACTIONS.UPDATE_CATALOGUE_ID:
      return { ...state, catalogId: action.payload, isEdit: true };
    case ACTIONS.UPDATE_REFRESH_RATE:
      return { ...state, refreshRate: action.payload, isEdit: true };
    case ACTIONS.UPDATE_ADDITIONAL_FEATURES:
      return { ...state, additionalFeatures: action.payload, isEdit: true };
    case ACTIONS.UPDATE_PERSONALITY:
      return { ...state, personality: action.payload, isEdit: true };
    case ACTIONS.UPDATE_EDIT_FLAG:
      return { ...state, isEdit: action.payload };
    case ACTIONS.UPDATE_ERRORS:
      return { ...state, errors: action.payload };
    case ACTIONS.SET_ACCORDIAN_ACTIVE:
      return { ...state, isAdditionalFeatureAccordianActive: action.payload };
    case ACTIONS.SET_LOADING:
      return { ...state, isLoading: action.payload };
    case ACTIONS.SET_TRAINING_STATUS:
      return { ...state, trainingStatus: action.payload };
    case ACTIONS.AFTER_SAVE_STATE:
      return { ...state, afterSaveState: action.payload };
    case ACTIONS.SET_HSL:
      return { ...state, hslValue: action.payload, isEdit: true };
    case ACTIONS.SET_FILTER_TOGGLE:
      return { ...state, userDetailsToggle: action.payload, isEdit: true };
    case ACTIONS.SET_CATALOG_STORE_FILTER_KEY:
      return { ...state, catalogFilterKey: action.payload, isEdit: true };
    case ACTIONS.SET_USER_KEY:
      return { ...state, userKey: action.payload, isEdit: true };
    default:
      return state;
  }
};

const syncTimeOptions = [];
for (let i = 1; i <= 24; i++) {
  syncTimeOptions.push({ text: `${i}` });
}

const CheckBoxWithInfo = ({
  marginLeft = '24px',
  label = '',
  info = '',
  value = false,
  onChange = () => {},
  disabled = false,
}) => {
  return (
    <Box padding="0" marginLeft={marginLeft}>
      <Checkbox.Item
        value={value}
        onChange={onChange}
        label={label}
        disabled={disabled}
      />
      <Tooltip themed tooltip={info} position="TOP">
        <InfoIconV4 size="small" iconColor="grey.dark" marginLeft="-20px" />
      </Tooltip>
    </Box>
  );
};

function GenAiSalesAssistant() {
  const [state, dispatch] = React.useReducer(reducer, intialState);

  const {
    isLoading,
    trainingStatus,
    brandName,
    productList,
    catalogId,
    refreshRate,
    additionalFeatures,
    personality,
    isEdit,
    afterSaveState,
    isAdditionalFeatureAccordianActive,
    errors,
    hslValue,
    userDetailsToggle,
    userKey,
    catalogFilterKey,
    catalogFilterList,
  } = state;

  const currentDomainInStore = CommonStore.getMetaTags().domain;
  const businessId = BotStore.getBusinessesLinkedToBot()?.[0]?.id;

  React.useEffect(() => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    API.businessV2.getGenAiSalesData(businessId).then((res) => {
      dispatch({ type: ACTIONS.SET_LOADING, payload: false });
      if (res.success && res?.response?.body && !res.response.body.error) {
        const {
          brand_name = '',
          catalogue_id = '',
          bot_tone = 'formal',
          is_followup_allowed = false,
          is_faq_allowed = false,
          is_buying_guidance_allowed = false,
          domains = [],
          sync_interval = '12',
          training_status = '',
          store_code_enabled = false,
          catalogue_store_filter_key = 'custom_label_0',
          allowed_catalogue_filter_keys = '',
          api_store_filter_key = '',
          error_bot_response = JSON.stringify({
            text: hslDefaultText,
            type: 'TEXT',
          }),
        } = res.response.body.client_details;
        const copy = JSON.parse(JSON.stringify(additionalFeatures));
        copy[0].value = is_faq_allowed;
        copy[1].value = is_followup_allowed;
        copy[2].value = is_buying_guidance_allowed;

        const payload = {
          brandName: brand_name,
          catalogId: catalogue_id,
          personality: {
            title: mapPersonalityListValueToTitle[bot_tone] ?? 'Formal',
            value: mapPersonalityListValueToTitle[bot_tone]
              ? bot_tone
              : 'formal',
          },
          additionalFeatures: copy,
          productList: domains,
          refreshRate: { text: sync_interval.toString() },
          trainingStatus: training_status,
          hslValue: JSON.parse(error_bot_response),
          userDetailsToggle: store_code_enabled,
          userKey: api_store_filter_key,
          catalogFilterKey: { text: catalogue_store_filter_key },
          catalogFilterList: allowed_catalogue_filter_keys
            .split(',')
            .map((val) => {
              return { text: val };
            }),
        };

        dispatch({ type: ACTIONS.SET_INITIAL_DATA, payload });
      } else {
        createAlert(
          res?.response?.body?.error || 'Something Went Wrong',
          null,
          AlertTypes.NEGATIVE
        );
      }
    });
  }, []);

  const validateFields = () => {
    let isError = false;
    const errorObj = {
      brandName: '',
      productList: '',
      catalogId: '',
    };
    if (!brandName.trim()) {
      errorObj.brandName = 'Brand Name is Empty';
      isError = true;
    }
    if (!catalogId.trim()) {
      errorObj.catalogId = 'Catalog ID is Empty';
      isError = true;
    }
    if (productList.length === 0)
      errorObj.productList = 'Key Product Categories are Empty';

    if (userDetailsToggle) {
      if (!userKey.trim()) errorObj.userKey = 'User Key is missing';

      if (!hslValue.text.trim()) errorObj.hsl = 'Error bot response is missing';
      else if (!hslValue?.data?.quick_replies?.length) {
        errorObj.hsl = 'Quick reply option not added in error bot response';
      }
    }

    Object.keys(errorObj).forEach((key) => {
      if (errorObj[key]) isError = true;
    });
    if (isError)
      createAlert('Some values are still empty', null, AlertTypes.NEGATIVE);

    dispatch({ type: ACTIONS.UPDATE_ERRORS, payload: errorObj });

    return isError;
  };

  const handleSave = () => {
    if (!validateFields()) {
      const payload = {
        name: brandName,
        catalogue_id: catalogId,
        bot_tone: personality.value,
        is_followup_allowed: additionalFeatures[1].value,
        is_faq_allowed: additionalFeatures[0].value,
        is_buying_guidance_allowed: additionalFeatures[2].value,
        domains: productList.join(','),
        sync_interval: parseInt(refreshRate.text, 10),
        action: API_ACTIONS.CREATE_CLIENT,
        error_bot_response: JSON.stringify(hslValue),
        catalogue_store_filter_key: catalogFilterKey.text,
        api_store_filter_key: userKey,
        store_code_enabled: userDetailsToggle,
      };

      dispatch({
        type: ACTIONS.AFTER_SAVE_STATE,
        payload: {
          state: 'loading',
          subMessage:
            "We're working on linking your Meta Catalog. This may take a moment. Please wait.",
          mainMessage: 'Connecting Meta Catalog',
        },
      });

      API.businessV2.updateGenAiSalesData(payload, businessId).then((res) => {
        if (res?.response?.error || !res.success) {
          dispatch({
            type: ACTIONS.AFTER_SAVE_STATE,
            payload: {
              state: 'error',
              subMessage: res?.response?.error || 'Something Went Wrong',
              mainMessage: res?.response?.error || 'Something Went Wrong',
            },
          });
        } else {
          dispatch({ type: ACTIONS.UPDATE_EDIT_FLAG, payload: false });
          dispatch({
            type: ACTIONS.AFTER_SAVE_STATE,
            payload: {
              state: 'success',
              subMessage: `Congratulations! Your Meta Catalog for ${currentDomainInStore.title} has been successfully connected. You're all set to enhance your Gen AI Sales Assistant setup`,
              mainMessage: 'Meta Catalog Connected Successfully',
            },
          });
        }
      });
    }
  };

  const handleTrain = () => {
    const payload = {
      action: API_ACTIONS.TRAIN_CLIENT,
    };
    API.businessV2.updateGenAiSalesData(payload, businessId).then((res) => {
      if (res?.response?.body?.status === 'started')
        dispatch({ type: ACTIONS.SET_TRAINING_STATUS, payload: 'running' });
      else createAlert('Something Went Wrong', null, AlertTypes.NEGATIVE);
    });
  };

  const handleChangeUserDetailsFilter = (value, action) => {
    dispatch({ type: action, payload: value });
    if (action === ACTIONS.SET_USER_KEY && errors.userKey) {
      dispatch({
        type: ACTIONS.UPDATE_ERRORS,
        payload: { ...errors, userKey: false },
      });
    }
    if (action === ACTIONS.SET_HSL && errors.hsl) {
      dispatch({
        type: ACTIONS.UPDATE_ERRORS,
        payload: { ...errors, hsl: false },
      });
    }
  };

  const disableAllFields = trainingStatus === 'running' || isProduction();

  if (isLoading) {
    return <StyledLoader />;
  }

  return (
    <MainWrapper>
      <Wrapper>
        <Box padding="0" justifyContent="space-between" alignItems="center">
          <Text color="black.haptik" variant="h2.semi-bold">
            Gen AI Sales Assistant Setup
          </Text>
          <Box padding="0" alignItems="center">
            {isEdit ? (
              <StyledButton
                themed
                type={Button.TYPES.PRIMARY}
                disabled={!isEdit}
                onClick={handleSave}
              >
                Save
              </StyledButton>
            ) : (
              <Tooltip
                themed
                tooltip={
                  trainingStatus === 'running'
                    ? 'No modifications can be made while training is in-progress.'
                    : 'No modifications have been made to the inputs; therefore, there are no changes to save.'
                }
                position="BOTTOM"
              >
                <StyledButton themed type={Button.TYPES.PRIMARY} disabled>
                  Save
                </StyledButton>
              </Tooltip>
            )}

            {isProduction() ||
            ((isEdit || !brandName.trim()) && trainingStatus !== 'running') ? (
              <Tooltip
                themed
                tooltip="First, save the inputs to activate the 'Train' button."
                position="BOTTOM"
              >
                <TrainButton themed disabled variant="disabled">
                  <Box padding="0" alignItems="center">
                    <Icon src={TrainIcon} />
                    {trainingStatus === 'running' ? <Training /> : 'Train'}
                  </Box>
                </TrainButton>
              </Tooltip>
            ) : (
              <TrainButton
                isGenAi
                onClick={handleTrain}
                themed
                disabled={trainingStatus === 'running'}
                variant={
                  trainingStatus === 'running' ? 'disabled' : 'secondary'
                }
              >
                <Box padding="0" alignItems="center">
                  <Icon src={TrainIcon} />
                  {trainingStatus === 'running' ? <Training /> : 'Train'}
                </Box>
              </TrainButton>
            )}
          </Box>
        </Box>
        <StyledTextInput
          disabled={disableAllFields}
          marginTop="16px"
          error={errors.brandName}
          themed
          label={
            <Label
              text="Brand Name"
              info="Enter your brand's name as it should be recognized by the Assistant."
            />
          }
          placeholder="Enter the brand name here"
          value={brandName}
          onChange={(val) => {
            dispatch({ type: ACTIONS.UPDATE_BRAND_NAME, payload: val });
            if (errors.brandName)
              dispatch({
                type: ACTIONS.UPDATE_ERRORS,
                payload: { ...errors, brandName: false },
              });
          }}
        />
        <StyledChips
          disabled={disableAllFields}
          chiperror={errors.productList}
          label={
            <Label
              text="Key Product Categories sold by the Brand"
              info="Specify up to 4 main product verticals sold by your brand."
            />
          }
          themed
          placeholder="For example Makeup, Skincare, Wellness & Beauty Products"
          value={productList}
          onChange={(list) => {
            dispatch({ type: ACTIONS.UPDATE_PRODUCT_LIST, payload: list });
            if (errors.productList)
              dispatch({
                type: ACTIONS.UPDATE_ERRORS,
                payload: { ...errors, productList: false },
              });
          }}
        />
        {errors.productList && (
          <Box padding="0" flexDirection="column" marginTop="-16px">
            <Text variant="h4.semi-bold" color="red.haptik">
              {errors.productList}
            </Text>
          </Box>
        )}
        <Box
          padding="0"
          marginTop={errors.productList ? '24px' : '0px'}
          style={{ gap: '16px' }}
        >
          <Box padding="0" flexDirection="column" flex="1">
            <StyledTextInput
              disabled={disableAllFields}
              error={errors.catalogId}
              themed
              label={
                <Label
                  text="Meta Catalog ID"
                  info="FB catalog ID to train the assistant on your product data. Needs to be shared with Haptik"
                />
              }
              placeholder="Enter your Meta Catalog ID here"
              value={catalogId}
              onChange={(val) => {
                dispatch({ type: ACTIONS.UPDATE_CATALOGUE_ID, payload: val });
                if (errors.catalogId)
                  dispatch({
                    type: ACTIONS.UPDATE_ERRORS,
                    payload: { ...errors, catalogId: false },
                  });
              }}
            />
          </Box>

          <Box padding="0" flexDirection="column" flex="1">
            <StyledDropdown
              disabled={disableAllFields}
              withSearch
              themed
              placeholder="Select Catalog Sync Time"
              options={syncTimeOptions}
              label={
                <Label
                  text="Catalog Sync Time in Hours"
                  info="Choose how often the catalog data syncs with the Assistant, from 1 to 12 hours."
                />
              }
              value={refreshRate}
              onChange={(val) => {
                dispatch({ type: ACTIONS.UPDATE_REFRESH_RATE, payload: val });
              }}
            />
          </Box>
        </Box>

        <AdditionalFeatures
          padding="16px"
          flexDirection="column"
          onClick={() => {
            if (!isAdditionalFeatureAccordianActive) {
              dispatch({ type: ACTIONS.SET_ACCORDIAN_ACTIVE, payload: true });
            }
          }}
        >
          <Box
            padding="0"
            justifyContent="space-between"
            onClick={() => {
              if (isAdditionalFeatureAccordianActive) {
                dispatch({
                  type: ACTIONS.SET_ACCORDIAN_ACTIVE,
                  payload: false,
                });
              }
            }}
          >
            <Text color="black.haptik" variant="h4.semi-bold">
              Advanced Options
            </Text>
            <StyledIcon
              src="angle-down"
              active={isAdditionalFeatureAccordianActive}
            />
          </Box>

          {isAdditionalFeatureAccordianActive && (
            <>
              <Box padding="0" marginTop="16px">
                <Text color="black.haptik" variant="h4.semi-bold">
                  Set Personality
                </Text>

                <Tooltip
                  themed
                  tooltip="Determine the Sales Assistant's communication style."
                  position="TOP"
                >
                  <InfoIconV4
                    size="small"
                    iconColor="grey.dark"
                    marginLeft="4px"
                  />
                </Tooltip>
              </Box>

              <Box padding="0" marginTop="16px">
                <Radio
                  disabled={disableAllFields}
                  value={{ title: personality.title }}
                  options={personalityList}
                  onChange={(value) => {
                    dispatch({
                      type: ACTIONS.UPDATE_PERSONALITY,
                      payload: value,
                    });
                  }}
                />
              </Box>

              <Text
                color="black.haptik"
                variant="h4.semi-bold"
                style={{ marginTop: '24px' }}
              >
                Additional Features
              </Text>

              <Box padding="0" marginTop="16px">
                {(additionalFeatures || []).map(({ title, info, value }, i) => {
                  return (
                    <CheckBoxWithInfo
                      disabled={disableAllFields}
                      value={value}
                      label={title}
                      info={info}
                      marginLeft={i > 0 ? '24px' : '0px'}
                      onChange={(val) => {
                        const copyAdditionalFeatures = JSON.parse(
                          JSON.stringify(additionalFeatures)
                        );
                        copyAdditionalFeatures[i].value = val;
                        dispatch({
                          type: ACTIONS.UPDATE_ADDITIONAL_FEATURES,
                          payload: copyAdditionalFeatures,
                        });
                      }}
                    />
                  );
                })}
              </Box>

              <UserDetailsFilter
                disabled={disableAllFields}
                hslValue={hslValue}
                handleChangeUserDetailsFilter={handleChangeUserDetailsFilter}
                userDetailsToggle={userDetailsToggle}
                userKey={userKey}
                catalogFilterKey={catalogFilterKey}
                catalogFilterList={catalogFilterList}
                errors={errors}
              />
            </>
          )}
        </AdditionalFeatures>
      </Wrapper>
      <Modal
        hideCloseIcon={afterSaveState.state === 'loading'}
        themed
        active={afterSaveState.state}
        footerBorder={false}
        style={{
          paddingLeft: '82px',
          paddingRight: '82px',
        }}
        onClose={() => {
          if (!(afterSaveState.state === 'loading')) {
            dispatch({
              type: ACTIONS.AFTER_SAVE_STATE,
              payload: {
                state: '',
                subMessage: '',
                mainMessage: '',
              },
            });
          }
        }}
      >
        <Box
          flexDirection="column"
          padding="0"
          marginTop="32px"
          marginBottom="32px"
        >
          <Box
            flexDirection="column"
            padding="0"
            alignItems="center"
            width="100%"
          >
            <IconWrapper
              src={
                afterSaveState.state === 'loading'
                  ? LoadingIcon
                  : afterSaveState.state === 'error'
                  ? ErrorIcon
                  : SuccessIcon
              }
            />
          </Box>
          <Box
            marginTop="32px"
            flexDirection="column"
            padding="0"
            alignItems="center"
            width="100%"
          >
            <Text variant="display-2.semi-bold" color="black.haptik">
              {afterSaveState.mainMessage}
            </Text>
          </Box>

          <Box
            flexDirection="column"
            padding="0"
            alignItems="center"
            width="415px"
            marginTop="16px"
            style={{ textAlign: 'center' }}
          >
            <Text color="black.haptik" variant="body.lg">
              {afterSaveState.subMessage}
            </Text>
          </Box>
        </Box>
      </Modal>
    </MainWrapper>
  );
}

export default GenAiSalesAssistant;
